import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { StorageService } from 'src/app/providers/storage.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { NavigationService } from '../../../providers/navigation.service';

@Component({
  selector: 'sm-all-business-info',
  templateUrl: './all-business-info.component.html',
  styleUrls: ['./all-business-info.component.scss']
})
export class AllBusinessInfoComponent implements OnInit {
  @ViewChild('dateTemplate', { static: true })
  dateTemplateRef!: TemplateRef<HTMLElement>;
  tableColumns: ITableColumnHeader[] = [];
  businessInfoList: any[] = [];

  constructor(private _storageService: StorageService, private _navService: NavigationService) { 
    this._navService.hideSidebarAndNav = false;
  }

  ngOnInit(): void {
    this.tableColumns = [
      {
        columnName: 'business name',
        columnProperty: 'entityName'
      },
      {
        columnName: 'address',
        columnProperty: 'entityCity'
      },
      {
        columnName: 'mobile',
        columnProperty: 'entityPhone'
      },
      {
        columnName: 'Pack name',
        columnProperty: 'planName'
      },
      {
        columnName: 'subscription start',
        columnProperty: 'fromDate',
        columnTemplate: this.dateTemplateRef
      },
      {
        columnName: 'subscription end',
        columnProperty: 'toDate',
        columnTemplate: this.dateTemplateRef
      }
    ];

    const storedSubscriptionData = JSON.parse(this._storageService.getValueFromAppStorage(SM_CONSTANTS.USER_SUBSCRIPTION_DATA));
    // console.log(storedSubscriptionData);
    this.businessInfoList = storedSubscriptionData.businessSubsInfo ?  storedSubscriptionData.businessSubsInfo  : []
    // this.businessInfoList = storedSubscriptionData.businessSubsInfo;
  }

}
